import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=597abbca&scoped=true&"
import script from "./Popover.vue?vue&type=script&setup=true&lang=js&"
export * from "./Popover.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=597abbca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597abbca",
  null
  
)

export default component.exports